module.exports = __webpack_public_path__ + "img/model3.8b572cb0.png";